// Custom polyfills: code in node_mobules is not parsed by webpack (expected to be already parsed)
// that is why some needed polyfills are not added automatically
import 'core-js/modules/es.number.is-nan'; // For Swiper
import 'core-js/modules/es.array.includes'; // For older browsers
import 'unfetch/polyfill';